define('home/ActivityFactory',[
    'underscore',

    'home/activityExpander',
    'core/UniqueModel',
    'home/models/Activity',

    'home/models/activities/FavoriteChannelThreadActivity',
    'home/models/activities/ChannelPostActivity',
    'home/models/activities/FavoriteThreadActivity',
    'home/models/activities/ReplyActivity',
    'home/models/activities/MentionActivity',
    'home/models/activities/PostActivity',
    'home/models/activities/LikePostActivity',
    'home/models/activities/TrendingThreadActivity',
    'home/models/activities/FollowUserActivity',
    'home/models/activities/AnnouncementActivity',
    'home/models/activities/CreateThreadActivity',
    'home/models/activities/ShareThreadActivity',
    'home/models/activities/ThreadInviteActivity',
    'home/models/activities/ChannelInviteActivity',
    'home/models/activities/HighlightPostActivity',
    'home/models/activities/AddModActivity',
], function (
    _,

    activityExpander,
    UniqueModel,
    Activity,

    FavoriteChannelThreadActivity,
    ChannelPostActivity,
    FavoriteThreadActivity,
    ReplyActivity,
    MentionActivity,
    PostActivity,
    LikePostActivity,
    TrendingThreadActivity,
    FollowUserActivity,
    AnnouncementActivity,
    CreateThreadActivity,
    ShareThreadActivity,
    ThreadInviteActivity,
    ChannelInviteActivity,
    HighlightPostActivity,
    AddModActivity
) {
    'use strict';

    var ActivityFactory = function () {};

    var methods = {
        createActivity: function (attributes, options) {
            var ActivityClass = this.getActivityClass(attributes, options);
            if (!ActivityClass)
                return null;

            var activity = new ActivityClass(attributes, options);

            // Must invoke UniqueModel after instantiating the model
            // because we do not have the final model id until after
            // instantiation
            return UniqueModel.set(Activity, activity);
        },

        getActivityClass: function (attributes, options) {
            switch (attributes.type) {
            case 'RegisteredUserFavoriteThread':
            case 'AnonymousUserFavoriteThread':
                if (attributes.routings[0].type === 'ThreadAuthorRelation') {
                    attributes.verb = FavoriteChannelThreadActivity.prototype.defaults.verb;
                    return FavoriteChannelThreadActivity;
                }

                attributes.verb = FavoriteThreadActivity.prototype.defaults.verb;
                return FavoriteThreadActivity;
            case 'RegisteredUserSubmitPost':
            case 'AnonymousUserSubmitPost':
                var object = activityExpander.buildPost(
                    options.objects,
                    attributes.object
                );
                attributes.object = object;
                if (attributes.routings[0].type === 'ThreadAuthorRelation') {
                    attributes.verb = ChannelPostActivity.prototype.defaults.verb;
                    return ChannelPostActivity;
                } else if (object.get('parent_post')) {
                    attributes.verb = ReplyActivity.prototype.defaults.verb;
                    return ReplyActivity;
                }

                attributes.verb = PostActivity.prototype.defaults.verb;
                return PostActivity;
            case 'UserMentionUserOnPost':
                attributes.verb = MentionActivity.prototype.defaults.verb;
                return MentionActivity;
            case 'RegisteredUserLikePost':
            case 'AnonymousUserLikePost':
                attributes.verb = LikePostActivity.prototype.defaults.verb;
                return LikePostActivity;
            case 'RegisteredUserCreateThread':
                attributes.verb = CreateThreadActivity.prototype.defaults.verb;
                return CreateThreadActivity;
            case 'TrendingThread':
            case 'TrendingThreadOnChannel':
            case 'TrendingThreadOnForum':
                attributes.verb = TrendingThreadActivity.prototype.defaults.verb;
                return TrendingThreadActivity;
            case 'UserFollowUser':
                attributes.verb = FollowUserActivity.prototype.defaults.verb;
                return FollowUserActivity;
            case 'SendAnnouncementToUser':
                attributes.verb = AnnouncementActivity.prototype.defaults.verb;
                return AnnouncementActivity;
            case 'UserShareThreadToChannel':
                attributes.verb = ShareThreadActivity.prototype.defaults.verb;
                return ShareThreadActivity;
            case 'UserInviteUserToThread':
            case 'UserInviteUserGroupToThread':
                attributes.verb = ThreadInviteActivity.prototype.defaults.verb;
                return ThreadInviteActivity;
            case 'UserInviteUserToChannel':
                attributes.verb = ChannelInviteActivity.prototype.defaults.verb;
                return ChannelInviteActivity;
            case 'UserAddModeratorToForum':
                attributes.verb = AddModActivity.prototype.defaults.verb;
                return AddModActivity;
            case 'UserHighlightPost':
                attributes.verb = HighlightPostActivity.prototype.defaults.verb;
                return HighlightPostActivity;
            case 'UserFollowForum':
                // Not supported
                return null;
            }
        },
    };

    _.extend(ActivityFactory.prototype, methods);

    return ActivityFactory;
});

